<template>
  <div class="feed" id="community">
    <div class="feed-header">
      <div class="tag">#MYHONOR</div>
      <div class="tag">#FORTHEBRAVE</div><br><br>
      <a href="https://www.instagram.com/huaweisverige/" target="_blank"><i class="fa fa-instagram"></i> Follow us on Instagram @huaweisverige</a>
    </div>
    <div class="feed-container">
      <div v-masonry class='instagrams' transition-duration="0.3s" item-selector=".instagram" fit-width="true">
        <div v-masonry-tile class='instagram' v-for="(gram, index) in grams" v-if="(pageSize * atPage) > index" v-on:click="openGram(gram)" v-bind:class="{ youtube: gram.type === 'youtube' }" v-bind:style="{ backgroundImage: 'url(' + gram.images.standard_resolution.url + ')', width: imageWidth + 'px', height: getHeight(gram.images.standard_resolution.width, gram.images.standard_resolution.height, imageWidth) + 'px' }">
          <div class="inside">
            <div class="table">
              <div class="table-cell">
                <div class="hearts"><i class="fa fa-heart"></i> {{gram.likes.count}}</div><br>
                {{gram.user.username}}
              </div>
            </div>
          </div>
          <div class='outside'>
            <div class='profile' v-if="gram.type !== 'youtube'" v-bind:style="{ backgroundImage: 'url(' + gram.user.profile_picture + ')' }"></div> 
            <div class='profile' v-if="gram.type === 'youtube'"><i class="fa fa-youtube"></i></div> 
            {{gram.user.username}}
          </div>
        </div>
      </div>
      <div style="text-align: center; margin-bottom: 40px; margin-top: 30px;">
        <div v-if="grams.length > (atPage * pageSize)" v-on:click="atPage++" class="load-more button">See more</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import db from '@/classes/Db'
export default {
  name: 'feed',
  data () {
    return {
      instagrams: [],
      imageWidth: 340,
      instaWidth: 1600,
      ww: null,
      atPage: 1,
      pageSize: 20
    }
  },
  computed: {
    grams () {
      if (this.instagrams.length < 1) {
        return []
      }
      let arr = []
      for (var i in this.instagrams) {
        if (this.instagrams.hasOwnProperty(i)) {
          arr.push(this.instagrams[i])
        }
      }
      return arr.sort((a, b) => {
        return b.created_time - a.created_time
      })
    }
  },
  methods: {
    render () {
      this.ww = window.innerWidth
    },
    openGram (gram) {
      this.$store.commit('setOverlay', {
        gram: gram,
        product: 'blue'
      })
      if (window.ga) {
        window.ga('send', 'event', 'Instagram', 'click', gram.id + ' - ' + gram.user.username)
        window.ga('clientTracker.send', 'event', 'Instagram', 'click', gram.id + ' - ' + gram.user.username)
      }
    },
    joinObjects (source, target) {
      for (var key in source) {
        if (source.hasOwnProperty(key)) {
          target[key] = source[key]
        }
      }
    },
    getLatestInstagrams () {
      let hashtag = ''
      let self = this
      axios.get('https://accomplice.se/services/socialacc/hashtag/' + hashtag)
        .then((response) => {
          self.instagrams = response.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getLatestSaved () {
      db.database().ref('grams').once('value').then((snapshot) => {
        this.instagrams = snapshot.val()
      })
    },
    getHeight (width, height, imageWidth) {
      return imageWidth * (height / width)
    }
  },
  beforeMount () {
    //  this.render()
  },
  mounted () {
    window.onresize = this.render
    this.getLatestSaved()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a {
    color: inherit;
    text-decoration: inherit;
  }
  .feed {
    width: 100vw;
    overflow-x: hidden;
  }
  .feed-container {
    position: relative;
  }
  .instagram .outside {
    position: absolute;
    bottom: -40px;
    font-size: 13px;
    letter-spacing: 0.5px;
    font-weight: bold;
    text-transform: uppercase;
  }
  .instagram .profile {
    height: 33px;
    width: 33px;
    margin-right: 10px;
    vertical-align: middle;
    display: inline-block;
    background-size: contain;
  }
  .instagram.youtube {
  }
  .instagram.youtube .profile i {
    font-size: 24px;
  }
  .feed-header {
    text-align: center;
    padding: 20px;
    padding-top: 50px;
  }
  .tag {
    font-family: 'BigNoodleTitling';
    display: inline-block;
    padding: 0px 10px;
    font-size: 40px;
    color: #808080;
  }
  .table {
    display: table;
    height: 100%;
    width: 100%;
    vertical-align: middle;
  }
  .table-cell {
    display: table-cell;
    height: 100%;
    width: 100%;
    vertical-align: middle;
  }
  .instagram {
    vertical-align: top;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: bottom center;
    margin: 30px;
    -ms-transform: scale(1); /* IE 9 */
    -webkit-transform: scale(1); /* Safari */
    transform: scale(1);
    margin-bottom: 50px;
    -webkit-transition: all 300ms;
    transition: all 300ms;
    cursor: pointer;
    z-index: 1;
  }
  .instagram:hover {
    -ms-transform: scale(1.04); /* IE 9 */
    -webkit-transform: scale(1.04); /* Safari */
    transform: scale(1.04);
    -webkit-box-shadow: 0px 0px 102px -1px rgba(0,0,0,0.27);
    -moz-box-shadow: 0px 0px 102px -1px rgba(0,0,0,0.27);
    box-shadow: 0px 0px 102px -1px rgba(0,0,0,0.27);
    z-index: 99;
  }
  .instagrams {
    text-align: center;
    width: 100%;
    margin: auto;
  }
  .feed-container {
    width: 100%;
    margin: auto;
    max-width: 1600px;    
  }
  .instagram .inside {
    display: none;
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    padding: 20px;
    height: 100%;
    width: 100%;
    color: #fff;
    box-sizing: border-box;
    vertical-align: middle;
    background-color: rgba(0, 0, 0, 0.7);

    font-family: 'BigNoodleTitling';
    letter-spacing: 1px;
    font-size: 30px;
  }
  .instagram:hover .inside {
    display: table;
  }
  @media only screen and (max-width: 900px) {
    .instagram {
      width: calc(100vw - 60px) !important;
      box-sizing: border-box;
    }
    .instagram .inside, .instagram:hover .inside {
      display: none;
    }
  }


</style>



// WEBPACK FOOTER //
// Feed.vue?57fc60aa